import { render, staticRenderFns } from "./RedeemLogList.vue?vue&type=template&id=74e79cbe&"
import script from "./RedeemLogList.vue?vue&type=script&lang=js&"
export * from "./RedeemLogList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports